export default {
    module: 'views/header'
};
